import classNames from "classnames";
import { useContext, useRef, useState } from "react";
import { RawResizable, flexStyles, positionStyles } from "ui";
import { BlocksContext } from "../../BlocksContext";
import { InlineImage } from "../../components/InlineImage";
import { Editor } from "./Editor";

interface ImageBlockProps {
  image: string;
  alt: string;
  url: string;
  caption: string;
  pixelWidth: number;
  updateBlock: (
    props: Partial<{
      image: string;
      alt: string;
      url: string;
      caption: string;
      pixelWidth: number;
    }>,
  ) => void;
}

export function ImageBlock({ image, alt, url, caption, pixelWidth, updateBlock }: ImageBlockProps) {
  const { NewImage, EditPopover } = useContext(BlocksContext);
  const ref = useRef<HTMLDivElement>(null);
  const [isEditorOpen, setIsEditorOpen] = useState(false);

  const handleUpdate = (
    values: Partial<{
      image: string;
      alt: string;
      url: string;
      caption: string;
      pixelWidth: number;
    }>,
  ) => {
    updateBlock(values);
    setIsEditorOpen(false);
  };

  const maxWidth = ref.current && ref.current.clientWidth - 4;

  return (
    <div ref={ref} className={classNames(positionStyles.relative, flexStyles.vert, flexStyles.alignCenter)}>
      {image ? (
        <RawResizable
          maxWidth={maxWidth}
          initialWidth={pixelWidth}
          onWidthChange={(width) => updateBlock({ pixelWidth: width })}
        >
          <InlineImage alt={alt} image={image} caption={caption} pixelWidth={pixelWidth} />
        </RawResizable>
      ) : (
        <NewImage onUpload={(imageUrl) => updateBlock({ image: imageUrl })} />
      )}
      <EditPopover
        isOpen={isEditorOpen}
        onOpen={() => setIsEditorOpen(!isEditorOpen)}
        showEditButton={!!image}
        editor={
          <Editor
            alt={alt}
            url={url}
            caption={caption}
            onUpdate={handleUpdate}
            onClose={() => setIsEditorOpen(false)}
          />
        }
      />
    </div>
  );
}
